<template>
  <div ref="LvDropdownMultiCategorySelect" class="lv-dropdown-multi-category-select">
    <p v-if="title" class="lv-dropdown-multi-category-select_title">
      {{ $t(title) }}<span v-if="required" class="red">*</span>
    </p>
    <div class="lv-dropdown-multi-category-select_content-wrap" v-click-outside="$_onCloseMenu">
      <div
        class="lv-dropdown-multi-category-select_content"
        :class="{
          outline: outline,
          narrow: narrow,
          wide: wide,
          disabled: disabled,
          error: validationErrors.length > 0,
        }"
      >
        <i v-if="leadingIcon" class="icon leading-icon" :class="leadingIcon" />
        <LvFlexBox v-if="isLoadingItems" :style="{ height: '100%' }">
          <LoadingAnimate primary class="ml-16" />
        </LvFlexBox>
        <button v-else class="input-button" @click="$_onClick()">
          <p class="select">
            {{ _selectItems }}
          </p>
          <p
            v-if="_selectAmount > 0"
            class="num"
            :class="{ 'has-cancel-icon': _isDisplayCancelIcon }"
          >
            {{ _selectAmount }}
          </p>
          <i v-if="_isDisplayCancelIcon" class="cancel-icon icon-cancel" @click.stop="$_onCancel" />
        </button>
        <i
          v-if="outline || disabled"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{ show: dropdownMenuShow }"
        />
        <i
          v-else-if="!outline && !dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <transition mode="out-in">
          <div
            v-if="dropdownMenuShow && !isActive.create"
            class="lv-dropdown-menu"
            :class="{
              'drop-up': scroll !== undefined ? isDropUp : false,
            }"
          >
            <div v-if="!isLoadingItems" class="search-tool">
              <SearchInput
                v-model="search.value"
                :placeholder="search.placeholder"
                :text-label="search.textLabel"
                @enter="$_search"
              />
            </div>
            <DotLoading v-if="isLoadingItems" />
            <perfect-scrollbar v-else class="ps lv-dropdown-scrollable-content short-height">
              <div v-for="(item, itemKey) in _menuItems" :key="itemKey" class="classification-list">
                <div v-if="item.title" class="classification-title">
                  <span>{{ $t(item.title) }}</span>
                </div>
                <div class="classification-subtitle">
                  <div v-for="(subItem, subItemKey) in item.menu" :key="subItemKey">
                    <label>
                      <input
                        type="checkbox"
                        :checked="$_getCheckState(itemKey, subItem.value)"
                        @change="$_onChange($event, subItem.value, itemKey)"
                      />
                      <div class="checkbox-icon">
                        <i class="checked icon-check-box" />
                        <i class="unchecked icon-check-box-outline-blank" />
                      </div>
                      <span>{{ subItem.text }}</span>
                    </label>
                  </div>
                  <div v-if="item.menu.length == 0">-</div>
                </div>
              </div>
            </perfect-scrollbar>
            <div v-if="_hasManageScope && !isLoadingItems" class="lv-dropdown-menu_btns">
              <div
                v-if="scope.isCreatable"
                class="lv-dropdown-menu_btn"
                @click="$_onOpenCreateField()"
              >
                <i class="icon-add-circle lv-dropdown-menu_btn-icon" />
                <p class="lv-dropdown-menu_btn-text">
                  {{ _createBtnText }}
                </p>
              </div>
              <div v-if="_hasEditScope" class="lv-dropdown-menu_btn" @click="$_onOpenManagePopup()">
                <i class="icon-edit lv-dropdown-menu_btn-icon" />
                <p class="lv-dropdown-menu_btn-text">
                  {{ _manageBtnText }}
                </p>
              </div>
            </div>
          </div>
        </transition>
        <transition mode="out-in">
          <ValidationObserver
            v-if="isActive.create"
            ref="createObserve"
            class="lv-dropdown-menu"
            :class="{ show: isActive.create, 'drop-up': scroll !== undefined ? isDropUp : false }"
          >
            <div class="menu-title">
              <i class="icon-arrow-left menu-title_icon" @click="$_onCloseCreateField()" />
              <p class="menu-title_text">
                {{ _createBtnText }}
              </p>
            </div>
            <div class="create-content">
              <LlState
                v-for="(field, fieldKey) in createFields"
                :key="fieldKey"
                v-model="createData[fieldKey]"
                required
                :type="field.type"
                :title="field.title"
                :placeholder="field.placeholder"
                :rules="field.rules"
                :is-required="field.required"
              />
              <div class="btns">
                <div class="btn">
                  <WsButton001 out-line narrow @click="$_onCloseCreateField()">
                    {{ $t('取消') }}
                  </WsButton001>
                </div>
                <div class="btn">
                  <WsButton001 :isloading="isLoading.create" @click="$_onSubmitCreate()">
                    {{ $t('送出') }}
                  </WsButton001>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </transition>
      </div>
      <ValidationProvider v-slot="{ errors }" :rules="rules">
        {{ $_onSetValidationErrors(errors) }}
        <div v-if="errors.length > 0" class="invalid-text">
          <i class="icon-warning invalid-icon" />
          <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
            {{ $t(text_e) }}
          </p>
        </div>
        <input type="hidden" :value="_valueValidation" />
      </ValidationProvider>
    </div>
    <PopUp
      unbottom
      :title="_manageBtnText"
      :pop-up-active="isActive.management"
      @click="$_onCloseManagePopup()"
    >
      <LvPopupScrollContent
        :item-list="_customItemList"
        :isUpdatable="scope.isUpdatable"
        :isDeletable="scope.isDeletable"
        :emptyTitle="_emptyTitle"
        @delete-click="$_onOpenDeletePopup($event)"
        @edit-click="$_onOpenUpdatePopup($event)"
      />
    </PopUp>
    <PopUp
      unbottom
      :title="_deletePopupTitle"
      :isLoading="isLoading.deletePopup"
      :popUpActive="isActive.deletePopup"
      @click="$_onCloseDeletePopup()"
    >
      <LvText v-if="deletePopup.contentText" class="mb-4">{{ $t(deletePopup.contentText) }}</LvText>
      <div v-if="deletePopup.relatedModuleNumList && deletePopup.relatedModuleNumList.length">
        <LvText
          v-for="(item, itemIndex) in deletePopup.relatedModuleNumList"
          :key="itemIndex"
          class="mb-4"
          >{{ $t(item) }}</LvText
        >
      </div>
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001 out-line @click="$_onCloseDeletePopup()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_onSubmitDelete()">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      unbottom
      :clickOutsideClose="false"
      :pop-up-active="isActive.update"
      :title="$t(_updatePopupTitle)"
      @click="$_onCloseUpdatePopup()"
    >
      <LlCancelPopupContent v-if="isActive.update">
        <LlState
          v-for="(field, fieldKey) in updateFields"
          :key="fieldKey"
          v-model="updateData[fieldKey]"
          :type="field.type"
          :title="$t(field.title)"
          :isRequired="field.isRequired"
          :rules="field.rules"
          :textLength="field.textLength"
        />
        <template v-slot:buttons>
          <WsButton001 out-line @click="$_onCloseUpdatePopup()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_onSubmitUpdate()">
            {{ $t('送出') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import S_scope from '@/service/api/v1/scope';
import H_common from '@/helpers/common';

extend('required', {
  ...required,
  message: '此項目為必填',
});
extend('nospace', {
  validate: value => {
    if (/\s/.test(value)) {
      return false;
    } else {
      return true;
    }
  },
  message: '不可為空格',
});
export default {
  name: 'LvDropdownMultiCategorySelect',
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    rules: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    selectValue: {
      type: Object,
      default() {
        return {};
      },
    },
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    createFields: {
      type: Object,
      default() {
        return {};
      },
    },
    createUrl: {
      type: String,
      default: '',
    },
    manageBtnText: {
      type: String,
      default: '',
    },
    createBtnText: {
      type: String,
      default: '',
    },
    label: {
      type: String,
    },
    scope: {
      type: Object,
      default() {
        return {
          isCreatable: false,
          isUpdatable: false,
          isDeletable: false,
        };
      },
    },
    updatePopupTitle: {
      type: String,
    },
    updateFields: {
      type: Object,
      default() {
        return {};
      },
    },
    deletePopupTitle: {
      type: String,
    },
    scroll: {
      type: Number,
    },
    isLoadingItems: {
      type: Boolean,
      default: false,
    },
    setDeletePopupInfo: {
      type: Function,
    },
    showCancelIcon: {
      type: Boolean,
      default: false,
    },
    customValidFunction: {
      type: Function,
    },
  },
  data() {
    return {
      isLoading: {
        create: false,
        deletePopup: false,
      },
      dropdownMenuShow: false,
      createData: {},
      isActive: {
        create: false,
        management: false,
        deletePopup: false,
        update: false,
      },
      deleteData: {},
      updateData: {},
      search: {
        value: '',
        placeholder: this.$t('搜尋'),
        textLabel: this.$t('搜尋'),
      },
      searchItems: [],
      isDropUp: false,
      dropdownHeight: 0,
      dropdownTop: 0,
      windowHeight: 0,
      validationErrors: [],
      deletePopup: {
        contentText: '',
        relatedModuleNumList: [],
      },
    };
  },
  computed: {
    _menuItems() {
      return this.$_search();
    },
    _placeholder() {
      return this.placeholder ? this.$t(this.placeholder) : this.$t(`選擇`);
    },
    _selectItems() {
      const selectItems = [];
      if (this.menuItems.length > 0) {
        this.value.forEach((_value, _valueIndex) => {
          if (this.menuItems[_valueIndex]) {
            this.menuItems[_valueIndex].menu.forEach(item => {
              if (this.value[_valueIndex] && this.value[_valueIndex].includes(item.value)) {
                selectItems.push(item.text);
              }
            });
          }
        });
      }
      if (selectItems.length > 0) {
        return selectItems.join('、');
      }
      return this.menuItems.textLabel ? this.menuItems.textLabel : this._placeholder;
    },
    _selectAmount() {
      let selectAmount = 0;
      if (this.value.length) {
        this.value.forEach(item => {
          if (item.length) {
            selectAmount = selectAmount + item.length;
          }
        });
      }
      return selectAmount;
    },
    _createBtnText() {
      return this.createBtnText ? this.$t(this.createBtnText) : this.$t(`新增${this.label}`);
    },
    _manageBtnText() {
      return this.manageBtnText ? this.$t(this.manageBtnText) : this.$t(`管理${this.label}`);
    },
    _updatePopupTitle() {
      return this.updatePopupTitle ? this.$t(this.updatePopupTitle) : this.$t(`編輯${this.label}`);
    },
    _deletePopupTitle() {
      return this.deletePopupTitle ? this.deletePopupTitle : `確定刪除嗎？`;
    },
    _hasManageScope() {
      const tarScopeList = ['isCreatable', 'isUpdatable', 'isDeletable'];
      return S_scope.isScopeAvailable(tarScopeList, this.scope);
    },
    _hasEditScope() {
      const tarScopeList = ['isUpdatable', 'isDeletable'];
      return S_scope.isScopeAvailable(tarScopeList, this.scope);
    },
    _customItemList() {
      let customItemList = [];
      this.menuItems.forEach(item => {
        if (item.isCustom) {
          customItemList = [...customItemList, ...item.menu];
        }
      });
      return customItemList;
    },
    _valueValidation() {
      let valueValidate = null;
      this.value.forEach(_value => {
        if (_value.length) {
          valueValidate = this.value;
        }
      });
      return valueValidate;
    },
    _emptyTitle() {
      return '目前尚無資料';
    },
    _isDisplayCancelIcon() {
      return this.showCancelIcon && this.value?.flat().length > 0;
    },
  },
  watch: {
    scroll() {
      this.$_getDropdownHeight();
      this.$_isDropUp();
    },
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
    window.addEventListener('resize', this.$_getDropdownHeight);
    window.addEventListener('resize', this.$_isDropUp);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
    window.removeEventListener('resize', this.$_getDropdownHeight);
    window.removeEventListener('resize', this.$_isDropUp);
  },
  mounted() {
    this.$_getDropdownHeight();
    this.$_isDropUp();
  },
  methods: {
    $_search() {
      if (!this.search.value) return this.menuItems;
      return this.menuItems.map(item => ({
        ...item,
        menu: item.menu.filter(subItem =>
          subItem.text.toLowerCase().includes(this.search.value.toLowerCase()),
        ),
      }));
    },
    $_getCheckState(firstLayerId, secondLayerId) {
      if (this.value[firstLayerId] && this.value[firstLayerId].includes(secondLayerId)) {
        return true;
      } else {
        return false;
      }
    },
    $_onClick() {
      if (this.disabled) return;
      this.$_onToggleMenu();
    },
    $_onToggleMenu() {
      this.dropdownMenuShow = !this.dropdownMenuShow;
      this.$emit('toggle', this.dropdownMenuShow);
    },
    $_onCloseMenu() {
      this.dropdownMenuShow = false;
      this.isActive.create = false;
      this.createData = {};
    },
    $_onChange($event, value, itemKey) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if ($event.target.checked) {
        if (newValue[itemKey] && !newValue[itemKey].includes(value)) {
          newValue[itemKey].push(value);
        } else if (!newValue[itemKey]) {
          newValue[itemKey] = [value];
        }
      } else {
        newValue[itemKey] = newValue[itemKey].filter(item => item !== value);
      }
      this.$emit('input', newValue);
      this.$emit('click');
    },
    $_onOpenCreateField() {
      this.dropdownMenuShow = false;
      this.isActive.create = true;
      const createData = {};
      for (const key in this.createFields) {
        createData[key] = null;
      }
      this.createData = createData;
    },
    $_onCloseCreateField() {
      this.isActive.create = false;
      this.createData = {};
      this.dropdownMenuShow = true;
    },
    async $_onSubmitCreate() {
      this.isLoading.create = true;
      const isValidate =
        (await this.$refs.createObserve.validate()) &&
        (this.customValidFunction ? this.customValidFunction(this.createData) : true);
      if (!isValidate) {
        this.$emit('validate-error');
        return;
      }
      try {
        await this.$axios.post(this.createUrl, this.createData);
        this.$emit('created');
      } catch (err) {
        alert(this.$t('新增發生錯誤'));
      } finally {
        this.isLoading.create = false;
      }
      this.$_onCloseMenu();
    },
    $_onOpenManagePopup() {
      this.isActive.management = true;
    },
    $_onCloseManagePopup() {
      this.isActive.management = false;
    },
    async $_onOpenDeletePopup($event) {
      this.deleteData = this.$_getTarItem($event);
      this.isActive.deletePopup = true;
      if (this.setDeletePopupInfo) {
        this.isLoading.deletePopup = true;
        const { contentText, relatedModuleNumList } = await this.setDeletePopupInfo(
          this.deleteData,
        );
        this.deletePopup = {
          contentText,
          relatedModuleNumList,
        };
        this.isLoading.deletePopup = false;
      }
      this.$emit('active-delete-popup', this.deleteData);
    },
    $_onCloseDeletePopup() {
      this.deleteData = {};
      this.isActive.deletePopup = false;
    },
    $_onOpenUpdatePopup($event) {
      const tarItem = this.$_getTarItem($event);
      const updateData = {
        value: $event,
      };
      for (const key in this.updateFields) {
        const getValueKey = this.updateFields[key].getValueKey
          ? this.updateFields[key].getValueKey
          : key;
        updateData[key] = tarItem[getValueKey];
      }
      this.updateData = updateData;
      this.isActive.update = true;
    },
    $_onCloseUpdatePopup() {
      this.updateData = {};
      this.isActive.update = false;
    },
    $_onSubmitDelete() {
      this.$emit('delete', this.deleteData);
      this.$_onCloseDeletePopup();
    },
    $_onSubmitUpdate() {
      this.$emit('update', this.updateData);
      this.$_onCloseUpdatePopup();
    },
    $_getTarItem(value) {
      let tarItem = null;
      this.menuItems.forEach(item => {
        if (item.isCustom) {
          const tarItemIndex = item.menu.findIndex(subItem => subItem.value === value);
          if (tarItemIndex >= 0) {
            tarItem = item.menu[tarItemIndex];
          }
        }
      });
      return tarItem;
    },
    $_handleResize() {
      this.windowHeight = window.innerHeight;
    },
    $_getDropdownHeight() {
      const { height, y } = H_common.getComponentHeightAndY(
        this.$refs.LvDropdownMultiCategorySelect,
      );
      this.dropdownHeight = height;
      this.dropdownTop = y;
    },
    $_isDropUp() {
      this.isDropUp = H_common.isDropUp(this.dropdownHeight, this.dropdownTop, 350, 350);
    },
    $_onSetValidationErrors(errors) {
      this.validationErrors = errors;
      return null;
    },
    $_onCancel() {
      this.$emit('input', [[], []]);
    },
  },
};
</script>
